import type { ComponentPropsWithoutRef } from 'react';
import { cx } from './cx';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

type ButtonStyle = { variant?: ButtonVariant; size?: ButtonSize; block?: boolean };

/** Button classes for any element — use on links: `<Link className={buttonClass({ size: 'lg' })}>` */
export function buttonClass({ variant = 'primary', size = 'md', block = false }: ButtonStyle = {}, className?: string): string {
  return cx('btn', `btn--${variant}`, size !== 'md' && `btn--${size}`, block && 'btn--block', className);
}

export function Button({ variant, size, block, className, type = 'button', ...props }: ComponentPropsWithoutRef<'button'> & ButtonStyle) {
  return <button type={type} className={buttonClass({ variant, size, block }, className)} {...props} />;
}
